import { finalize } from 'rxjs/operators';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  isLoading = new ReplaySubject<boolean>();

  private show(loadingSubject?: Subject<boolean>) {
    if (loadingSubject) {
      return loadingSubject.next(true);
    }

    this.isLoading.next(true);
  }

  private hide(loadingSubject?: Subject<boolean>) {
    if (loadingSubject) {
      return loadingSubject.next(false);
    }

    this.isLoading.next(false);
  }

  executeWithLoader<T>(
    observable: Observable<T>,
    loadingSubject?: Subject<boolean>
  ) {
    this.show(loadingSubject);

    return observable.pipe(
      finalize(() => {
        this.hide(loadingSubject);
      })
    );
  }
}
